import { COMPLIANCE_COLORS } from '../shared/utils.index';

const checkBatchCompliance = (batch) => {
  if (batch.delivery_note_data.some((a) => a.mash_control === true) === false) {
    return 3;
  } else if (
    batch.delivery_note_data.find(
      (a) =>
        a.mash_control === true &&
        (a.ave_strength_28_2 !== null || a.ave_strength_28_3 !== null) &&
        batch.n_control_mash < batch.min_n_control_mash,
    )
  ) {
    return 2;
  } else if (batch.compliance === true || batch.compliance90 === 1) {
    return 0;
  } else if (batch.compliance === false || batch.compliance90 === 0) {
    return 1;
  } else {
    // En este caso existen de control pero son notas de laboratorio a 28 dias
    return 3;
  }
};

const getResistenceComplianceBackground = (value) => {
  const complianceLevel = checkBatchCompliance(value.rawData);
  if (complianceLevel === 0) {
    return COMPLIANCE_COLORS.SUCCESS;
  }
  if (complianceLevel === 1) {
    return COMPLIANCE_COLORS.ERROR;
  }
  if (complianceLevel === 2) {
    return COMPLIANCE_COLORS.WARNING;
  }
  if (complianceLevel === 3) {
    return COMPLIANCE_COLORS.TRANSPARENT;
  }
};

export const getColumns = (intl, normative = 'ehe') => {
  const normativeTable =
    normative === 'ehe'
      ? { minMashes: '86.5.4.2', resistance: '86.5.4.3a' }
      : { minMashes: '57.5.4.1', resistance: '57.5.4.3.a' };

  const columns = {
    batch_code: {
      title: intl.formatMessage({
        id: 'pages.quality.normative.statistical-control.lotting.list.column.batch_code',
      }),
      dataIndex: 'batch_code',
      key: 'batch_code',
      align: 'center',
    },
    batch_volume: {
      title: intl.formatMessage({
        id: 'pages.quality.normative.statistical-control.lotting.list.column.batch_volume',
      }),
      dataIndex: 'batch_volume',
      key: 'batch_volume',
      align: 'center',
    },
    structural_elements: {
      title: intl.formatMessage({
        id: 'pages.quality.normative.statistical-control.lotting.list.column.structural_elements',
      }),
      dataIndex: 'structural_elements',
      key: 'structural_elements',
      align: 'center',
    },
    min_mashes_compliance: {
      title: intl.formatMessage(
        {
          id: 'pages.quality.normative.statistical-control.lotting.list.column.min_mashes_compliance',
        },
        { table: normativeTable.minMashes },
      ),
      dataIndex: 'min_mashes_compliance',
      key: 'min_mashes_compliance',
      align: 'center',
    },
    resistence_compliance: {
      title: intl.formatMessage(
        {
          id: 'pages.quality.normative.statistical-control.lotting.list.column.resistence_compliance',
        },
        { table: normativeTable.resistance },
      ),
      dataIndex: 'resistence_compliance',
      key: 'resistence_compliance',
      cellBackgroundFn: (value) => getResistenceComplianceBackground(value),
      align: 'center',
    },
    NC: {
      title: 'NC',
      dataIndex: 'NC',
      key: 'NC',
      align: 'center',
    },
  };

  // Para COE, añadir columna de amasadas mínimas de control antes de min_mashes_compliance
  if (normative === 'coe') {
    const orderedColumns = {
      batch_code: columns.batch_code,
      batch_volume: columns.batch_volume,
      structural_elements: columns.structural_elements,
      min_n_control_mash: {
        title: intl.formatMessage({
          id: 'pages.quality.normative.statistical-control.lotting.list.column.min_n_control_mash',
        }),
        dataIndex: 'min_n_control_mash',
        key: 'min_n_control_mash',
        align: 'center',
      },
      min_mashes_compliance: columns.min_mashes_compliance,
      resistence_compliance: columns.resistence_compliance,
      NC: columns.NC,
    };
    return orderedColumns;
  }

  return columns;
};
